import { Box, Divider } from "@mui/material";
import { useState } from "react";
import CustomTextArea from "../../../../../components/CustomTextArea";
import Flex from "../../../../../components/Flex";
import { ChatUser } from "./ChatUser";
import { SmsConsentInfo } from "./ConsentInfoBanner";
import MessageBox from "./MessageBox";
import { SendButton } from "./SendButton";

interface MessageContainerProps {
  user: any;
  onSend: (msg: string, user: any) => Promise<any>;
  messages?: Record<string, any[]>;
  hideTopBar?: boolean;
}

export const MessageContainer = ({
  user,
  onSend,
  messages,
  hideTopBar,
}: MessageContainerProps) => {
  const [msg, setMsg] = useState<string>("");

  return (
    <Flex flexDirection={"column"} width={"100%"} height={"100%"}>
      {!hideTopBar && (
        <Flex alignItems={"center"} pr={1} height={"68px"}>
          <ChatUser name={user?.patientName} />
        </Flex>
      )}

      {!hideTopBar && (
        <Divider
          sx={{ height: "1px", backgroundColor: "gray" }}
          orientation="horizontal"
        />
      )}

      <Flex
        p={1}
        flexDirection={"column"}
        flex={1}
        minHeight={0}
        sx={{ overflowY: "auto" }}
        gap={2}
      >
        <MessageBox messages={messages} />
      </Flex>

      <SmsConsentInfo sx={{ m: 1.2 }} />

      <Flex
        gap={2}
        alignItems={"center"}
        px={1.2}
        mb={1}
        paddingTop={1}
        borderTop={"1px solid rgb(229, 224, 224)"}
      >
        <CustomTextArea
          maxRows={7}
          sx={{
            borderRadius: "40px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "40px",
              "& fieldset": {
                borderRadius: "40px",
              },
            },
          }}
          fullWidth
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          placeholder="Type your message..."
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend(msg, user).then(() => setMsg(""));
            }
          }}
        />
        <Box>
          <SendButton
            onClick={() => onSend(msg, user).then(() => setMsg(""))}
          />
        </Box>
      </Flex>
    </Flex>
  );
};
